import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function NewsletterSection() {
  const { t } = useTranslation();
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    try {
      const res = await fetch('http://yjpslu.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '发送失败，请稍后再试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后再试');
      setStatus('error');
    }
  };

  return (
    <section className="py-14 md:py-18 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-500/20">
            <i className="ri-mail-send-line text-primary-400 text-3xl"></i>
          </div>

          <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-3">
            {t('newsletter.title')}
            <span className="text-primary-400">{t('newsletter.titleHighlight')}</span>
          </h2>
          <p className="text-background-400 text-sm mb-8 leading-relaxed">
            {t('newsletter.subtitle')}
          </p>

          {status === 'success' ? (
            <div className="flex items-center justify-center gap-2 text-accent-400 font-medium text-sm py-4">
              <i className="ri-checkbox-circle-line text-xl"></i>
              <span>订阅成功！第一手八卦即将送达你的邮箱。</span>
            </div>
          ) : (
            <>
              <form
                id="newsletter-form"
               
                onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
              >
                <div className="honeypot-wrapper">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder={t('newsletter.placeholder')}
                  required
                  className="flex-1 px-5 py-3.5 rounded-full bg-white/10 border border-white/20 text-white placeholder:text-white/40 text-sm focus:outline-none focus:border-primary-400 focus:bg-white/15 transition-all"
                />
                <button
                  type="submit"
                  className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer"
                >
                  {t('newsletter.button')}
                  <i className="ri-arrow-right-line ml-1.5"></i>
                </button>
              </form>
              {status === 'error' && (
                <p className="text-red-400 text-xs mt-3">{errorMsg}</p>
              )}
            </>
          )}

          <p className="text-background-500 text-xs mt-4">
            <i className="ri-shield-check-line mr-1"></i>
            {t('newsletter.privacy')}
          </p>
        </div>
      </div>
    </section>
  );
}